export default __webpack_public_path__ + "static/media/banner-mobile-2x.f035758f.jpg";